import Button from "components/common/Button";
import Typography from "components/common/Typography";
import { useTranslate } from "hooks/useTranslate";
import { useAppSelector } from "redux/hooks";
import { getUserName } from "utils/StoreUtils";

interface Props {
  setCurrentPage?: any;
}

function WelcomeWizard(props: Props) {
  const translate = useTranslate();

  const { checkApiResponse } = useAppSelector((state) => state.Onboarding);

  const { isFocusAreasExpired } = checkApiResponse;

  return (
    <>
      <Typography variant={"h4"}>
        {isFocusAreasExpired ? "Keep your profile up to date" : `Welcome, ${getUserName()}`}
      </Typography>
      <Typography>
        {isFocusAreasExpired
          ? "Your preferences may have evolved since your last setup. A quick review will help us personalize your experience with most relevant suggested plans."
          : "Welcome to Hilton BOOST! Set preferences that fit you and match your goals to tailor your experience."}
      </Typography>
      <Button variant="primary" label="Let's Start" width="150px" onClick={() => props.setCurrentPage(2)} />
    </>
  );
}

export default WelcomeWizard;
